import { render } from "./savepoint.vue?vue&type=template&id=2712d56e&scoped=true&ts=true"
import script from "./savepoint.vue?vue&type=script&lang=ts"
export * from "./savepoint.vue?vue&type=script&lang=ts"

import "./savepoint.vue?vue&type=style&index=0&id=2712d56e&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2712d56e"]])

export default __exports__